import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Paper, Typography } from '@mui/material'
import { GridCell } from '@mui/x-data-grid'

import { BOILERS_TABLE_COLUMNS } from '../../constants'
import { TableUrlPagination } from '../../../../ui'
import { boilersTableStyles } from './boilers-table.styles'
import { useBoilersContext } from '../../contexts'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const BoilersTable = () => {
  const { formatMessage } = useIntl()
  const {
    data,
    search,
    pagination: { total_viviendas: totalEntries },
    loading: isLoading,
  } = useBoilersContext()
  const combos = useSelector((state) => state.combos)

  //Column structure
  const formattedColumns = useMemo(
    () =>
      [...BOILERS_TABLE_COLUMNS].map((column) => {
        const baseColumn = {
          accessorKey: column.field,
          id: column.field,
          header: formatMessage({ id: `pages.boilers.table.columns.${column.field}.title` }),
          muiTableHeadCellProps: {
            align: column.align || 'left',
            sx: {
              '& .Mui-TableHeadCell-Content': {
                flexDirection: 'row',
                justifyContent: column.align === 'right' ? 'flex-end' : 'flex-start',
                width: '100%',
              },
            },
          },
          muiTableBodyCellProps: {
            align: column.align || 'left',
            sx: {
              textAlign: column.align || 'left',
            },
          },
        }

        // Add lookup functionality if combo data exists
        if (
          column.hasOwnProperty('comboId') &&
          combos[column.comboId] &&
          combos[column.comboId].data
        ) {
          const lookup = getLookup(combos[column.comboId].data)
          baseColumn.Cell = ({ cell }) => {
            const value = cell.getValue()
            return lookup[value] || value || <span>--</span>
          }
        } else {
          // Default cell renderer with empty value handling
          baseColumn.Cell = ({ cell }) => {
            const value = cell.getValue()
            return value || <span>--</span>
          }
        }

        return baseColumn
      }),
    [combos, formatMessage] // eslint-disable-line react-hooks/exhaustive-deps
  )

  //Assembling and adjusting data
  const processedData = useMemo(
    () =>
      data.map((item) => {
        return {
          ...item,
          nombre_via:
            `${item['tipo_via']} ${item['nombre_via']} ${item['numero']}` +
            `${item['anexo'] ? ' ' + item['anexo'] : ''} ` +
            `${item['bloque'] ? ' ' + item['bloque'] : ''} ` +
            `${item['escalera'] ? ' ' + item['escalera'] : ''} ` +
            `${item['piso'] ? '-' + item['piso'] : ''}`,
          tableData: {
            ...item.tableData,
          },
        }
      }),
    [data]
  )

  //Table configuration
  const tableOptions = useMemo(
    () => ({
      toolbar: false,
      selection: false,
      draggable: false,
    }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return (
    <>
      <TableUrlPagination
        columns={formattedColumns}
        options={tableOptions}
        totalEntries={totalEntries}
        search={search}
        data={processedData}
        isLoading={isLoading}
      />
      <Typography variant="body2" color="textSecondary">
        {formatMessage({ id: 'pages.boilers.table.footer.text' })}
      </Typography>
    </>
  )
}
